// @flow

/**
 * Chat Module Entry Point
 * Re-exports ChatWindow from ai-prompt-management for backward compatibility
 */

import { ChatWindow } from '../../ai-prompt-management';

export default ChatWindow;
